import React from 'react'
import { useI18n } from '../../../i18n'
import { getStandardDisplayName } from '../../../utils/complianceStandard'
import { Button } from '../../ui/Button'
import listStyles from '../../../styles/pages/governance/GovernanceListing.module.scss'

type Props = {
  standardCode: string
  stage: string
  progressLabel: string
  lastActivity?: string | null
  onContinue?: () => void
}

export function ControlExecutionHeader({ standardCode, stage, progressLabel, lastActivity, onContinue }: Props) {
  const { t } = useI18n()
  return (
    <header className={listStyles.panel}>
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
            {t('controlCentric.header.eyebrow', 'Operational Compliance Journey')}
          </p>
          <h2 className="text-lg font-semibold text-slate-900">
            {getStandardDisplayName(t, standardCode)} · {t('controlCentric.header.activeSession', 'Active execution session')}
          </h2>
          <p className="mt-1 text-sm text-slate-600">
            {t('controlCentric.header.stage', 'Stage')}: <span className="font-medium text-slate-900">{stage}</span>
          </p>
          <p className="text-sm text-slate-600">
            {t('controlCentric.header.progress', 'Progress')}: <span className="font-medium text-slate-900">{progressLabel}</span>
          </p>
          {lastActivity ? (
            <p className="mt-1 text-xs text-slate-500">
              {t('controlCentric.header.lastActivity', 'Last activity')}: {lastActivity}
            </p>
          ) : null}
        </div>
        {onContinue ? (
          <Button type="button" size="small" color="primary" className="!bg-green-600 hover:!bg-green-700 !border-green-600" onClick={onContinue}>
            {t('controlCentric.header.continue', 'Continue workflow')}
          </Button>
        ) : null}
      </div>
    </header>
  )
}
